import React, { RefObject } from 'react';
import cs from 'classnames';
import { injectV2 } from '../../../../injectV2';
import { ConfigStore } from '../../../../stores/ConfigStore';
import s from './TemplateVideo.scss';
import { templateVideoDataHooks } from './TemplateVideo.dataHooks';
import { Loader } from './Loader';

interface TemplateVideoProps {
  videoSource: string;
  dataHook?: string;
  isShowControls: boolean;
  videoRef: RefObject<HTMLVideoElement>;
  configStore: ConfigStore;
}

const TemplateVideoCmp: React.FC<TemplateVideoProps> = ({
  dataHook,
  videoSource,
  videoRef,
  configStore,
  isShowControls,
}) => {
  const [isVideoLoading, setIsVideoLoading] = React.useState<boolean>(false);
  const videoSrc = `//${configStore.config.filesMediaPlatformDomain}${videoSource}`;
  const setLoadingIfNotLoaded = () => {
    if (videoRef.current?.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
      setIsVideoLoading(true);
    }
  };

  const onDataLoaded = () => {
    setIsVideoLoading(false);
  };

  return (
    <div className={cs(s.root, { [s.loaded]: !isVideoLoading })} data-hook={dataHook}>
      <video
        tabIndex={-1}
        className={s.video}
        preload="auto"
        loop
        muted
        controls={isShowControls}
        ref={videoRef}
        onLoadedData={onDataLoaded}
        onPlay={setLoadingIfNotLoaded}
        data-hook={templateVideoDataHooks.video()}
      >
        <source src={videoSrc} type="video/mp4" data-hook={templateVideoDataHooks.videoSource()} />
      </video>
      <Loader dataHook={templateVideoDataHooks.loader()} isLoading={isVideoLoading} />
    </div>
  );
};

export const TemplateVideo = injectV2('configStore')(TemplateVideoCmp);
